import React from "react";

import { DialogTitleProps } from "./types";

import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      fontSize: theme.spacing(2),
      right: theme.spacing(1.7),
      top: theme.spacing(1.5),
      display: "inline-block",
      color: theme.palette.primary.main,
    },
  })
);

export const ModalDialogTitle = (props: DialogTitleProps) => {
  const classes = useStyles();
  const { children, onClose } = props;

  return (
    <MuiDialogTitle>
      {children}
      {onClose && (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};
